import { MaskitoOptions } from '@maskito/core';
import { maskitoDateOptionsGenerator, maskitoNumberOptionsGenerator } from '@maskito/kit';


export class Masks {

  static readonly idNumber: MaskitoOptions = {
    mask: /^\d{0,10}$/
  };

  static readonly phone: MaskitoOptions = {
    mask: /^\d{0,10}$/
  };

  static readonly date = maskitoDateOptionsGenerator({
    mode: 'dd/mm/yyyy',
    separator: '/'
  })

  static readonly durationMask = maskitoNumberOptionsGenerator({
    postfix: ' Días',
    min: 1
  });

  static readonly frequencyMask = maskitoNumberOptionsGenerator({
      postfix: ' Horas',
      min: 1
  });
}

